import { inject, NgModule } from '@angular/core';
import { UpdatesService } from './updates.service';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '@env';

@NgModule({
  providers: [
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),
  ],
})
export class UpdatesModule {
  readonly #_ = inject(UpdatesService);
}
